/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import { InitiativePlain, RootConfig, RootInitiativeData } from '../types/initiative';
import { AgreementConfig, AppConfig } from '../types/app';
import { GenericState } from '../slice/slice';

interface GlobalData {
  initiativeTree: InitiativePlain[];
  organization?: RootInitiativeData;
  config?: RootConfig;
  appConfig?: AppConfig;
  companyAgreementsRequired?: AgreementConfig[];
}

export interface GlobalDataStateLoaded extends GenericState<GlobalData> {
  loaded: true;
  initiativeId: string;
  lastUpdated: number;
  organization: RootInitiativeData;
}

export interface GlobalDataStateNotLoaded extends GenericState<object> {
  loaded: false;
  initiativeId?: string;
  lastUpdated?: number;
  organization?: RootInitiativeData;
}

export type GlobalDataState = GlobalDataStateLoaded | GlobalDataStateNotLoaded;

const globalData = (
  state: (GlobalDataStateLoaded | GlobalDataStateNotLoaded) = {
    data: {},
    loaded: false,
    loading: false,
    errored: false,
    initiativeId: '',
  },

  action: AnyAction

): (GlobalDataStateLoaded | GlobalDataStateNotLoaded) => {

  switch (action.type) {
    case actionTypes.LOADING_GLOBALDATA:
      return {
        ...state,
        initiativeId: action.initiativeId,
        organization: action.organization,
        data: {},
        loading: true,
        loaded: false,
        errored: false,
        lastUpdated: action.lastUpdated
      }
    case actionTypes.ERROR_GLOBALDATA:
      return {
        ...state,
        loading: false,
        errored: true,
        loaded: false,
        lastUpdated: undefined
      }
    case actionTypes.LOADED_GLOBALDATA:
      return {
        ...state,
        initiativeId: action.initiativeId,
        organization: action.organization,
        data: action.data,
        errored: false,
        loading: false,
        loaded: true,
        lastUpdated: action.lastUpdated,
      }
    default:
      return state;

  }

}

export default globalData;
